export default {
  SET_STARTPOLLING: function (state, payload) {
    state.startPolling = payload
  },
  SET_REQUIRETIMER: function (state, payload) {
    state.requireTimer = payload
  }
}
